// import { Modal } from 'antd';
// import EmojiPicker from 'emoji-picker-react';
import React, { useState, useCallback, useMemo, useRef, useEffect } from 'react';
import { FileDrop } from 'react-file-drop';
import { FormattedMessage, useIntl } from 'react-intl';
import { connect, useDispatch, useSelector } from 'react-redux';

import { signedUploadUrl } from '../../../../actions';
import { socketSendAction } from '../../../../redux/state-areas/socket/actions';
import { isSocketConnectedSelector } from '../../../../redux/state-areas/socket/selectors';
import { uploadTaskUrlAction } from '../../../../redux/tasks/actions';

import Icon from '../../atoms/global/Icon';
// import TextAreaFileHolder from '../../organisms/TextAreaFileHolder';

import TextEditorWrapper from '../editor/TextEditorWrapper';
import { checkContentForImages, checkContentForUploadingImage, prepareContentForSending } from '../editor/utils/editorContentOperations';
import { isMac } from '../../../../js/functions';

const TASK_CHAT_AREA_STYLES = {
  width: '100%',
  height: '100%',
  color: 'black',
  borderRadius: '5px',
  position: 'absolute',
  left: 0,
  top: 0,
};

const TaskChatArea = ({
  delAttachment,
  emojiPosition,
  fullScreen,
  roomId,
  socketConnected,
  taskId,
}) => {
  const intl = useIntl();
  const dispatch = useDispatch();

  const _internals = useRef({
    socketConnected: true
  })
  const textEditorRef = useRef({});

  // const [selectedEmoji, setSelectedEmoji] = useState('');
  // const [isModalOpen, setIsModalOpen] = useState(false);
  // const [isPasting, setIsPasting] = useState(false);

  const [comment, setComment] = useState('');
  const [trimmedTextContent, setTrimmedTextContent] = useState('');
  const [file, setFile] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [isDragNdropVisible, setIsDragNdropVisible] = useState(false);

  const { users } = useSelector((state) => state.userReducer);

  useEffect(() => {
    _internals.current = {
      socketConnected
    }
  }, [socketConnected]);

  useEffect(() => {
    console.info(`[TaskChatArea]: loaded taskId: ${taskId} with roomId: ${roomId?._id || roomId}`);
  }, [taskId, roomId]);

  const mentionOptions = useMemo(
    () =>
      users.map((user) => ({
        id: user._id,
        value: user.fullName,
        icon: user.avi,
      })),
    [users],
  );

  // const showModal = () => {
  //   setIsModalOpen(true);
  // };
  // const handleOk = () => {
  //   setIsModalOpen(false);
  // };
  // const handleCancel = () => {
  //   setIsModalOpen(false);
  // };
  // const handleEmoji = (emojiData) => {
  //   let sym = emojiData.unified.split('-');
  //   let codesArray = [];
  //   sym.forEach((el) => codesArray.push('0x' + el));
  //   let emoji = String.fromCodePoint(...codesArray);
  //   setSelectedEmoji(emojiData.unified);
  //   setComment(comment + emoji);
  // };

  // const handlePaste = async (e) => {
  //   setIsPasting(true);

  //   e.preventDefault();
  //   const pastedText = e.clipboardData.getData('text');
  //   if (pastedText) {
  //     setComment(comment + pastedText);
  //   }
  //   const pastedItems = e?.clipboardData?.items || [];
  //   const imageOrFiles = [];

  //   for (let item of pastedItems) {
  //     const isImageOrFile = item?.type?.indexOf('image') || item?.kind === 'file';
  //     if (isImageOrFile && item.getAsFile()) {
  //       imageOrFiles.push(item.getAsFile());
  //     }
  //   }
  //   imageOrFiles?.length > 0 &&
  //     changeHandler({
  //       target: {
  //         files: imageOrFiles,
  //       },
  //     });
  // };

  // const deleteFile = (fileId) => {
  //   delAttachment(fileId);
  //   const updatedFiles = file.filter((f) => f?.fileId !== fileId);
  //   setFile(updatedFiles);
  // };

  const handleSubmit = useCallback(() => {
    textEditorRef?.current?.commands?.submit();
  }, []);

  const changeHandler = async (e, isDropped = false) => {
    try {
      let fileList = [];
      let getFile = isDropped ? e : e.target.files;

      for (const file of getFile) {
        setIsLoading(true);
        const { signedUrl, fileId } = await dispatch(
          uploadTaskUrlAction(
            {
              fileName: file.name,
              taskId,
              type: file?.type,
              fileSize: file?.size,
            },
            undefined,
            intl,
          ),
        );
        setIsLoading(false);

        if (signedUrl) {
          await dispatch(signedUploadUrl(signedUrl, file));
        }

        fileList.push({
          fileId,
          file,
        });
      }

      setFile(fileList);
    } catch (error) {
      console.error(error);
    }
    document?.getElementById('file')?.remove();
  };

  const onFileDrop = async (files, e) => {
    setIsDragNdropVisible(false);
    document.querySelector('.onResize-ticket-drawer')?.classList.remove('disable-pointer-events-div');
    try {
      changeHandler(files, true);
    } catch (error) {
      console.error(error);
    }
  };

  const handleEditorChange = useCallback((content, trimmedContent) => {
    setComment(content);
    setTrimmedTextContent(trimmedContent);
  }, []);

  const handleTextEditorSubmit = useCallback((content, trimmedContent) => {
    if ((!trimmedTextContent && !trimmedContent) || !_internals?.current?.socketConnected) {
      return;
    }
    let messageDescription = (content || comment)?.trim();
    const fileIds = file.map((fileObj) => ({ _id: fileObj.fileId }));

    const hasContent =
      messageDescription.replace(/<p><br><\/p>/g, '').trim() ||
      messageDescription.includes('<img') ||
      messageDescription.includes('<custom-img') ||
      fileIds?.length > 0;

    if (!hasContent) return;

    const extraP = messageDescription.slice(-11);
    const extraBlock = messageDescription.slice(-29);
    if (extraP === '<p><br></p>') {
      messageDescription = messageDescription.substring(0, messageDescription.length - 11);
    }
    if (extraBlock === '<blockquote><br></blockquote>') {
      messageDescription = messageDescription.substring(0, messageDescription.length - 29);
    }

    const msg = {
      sender: { _id: localStorage.getItem('Id') },
      messageDescription: prepareContentForSending(messageDescription),
      files: fileIds,
      roomId: roomId?._id || roomId,
    };
    console.info(`[TaskChatArea]: submitting a message in task comments. roomId: ${roomId?._id || roomId}`, msg)
    dispatch(socketSendAction('message', msg));
    setFile([]);
    setComment('');
    setTrimmedTextContent('');
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [comment, file, roomId, trimmedTextContent]);

  const isImgUploadingInProgress = useMemo(() => checkContentForUploadingImage(comment), [comment]);

  const isSendBtnDisabled = useMemo(() => !socketConnected ||
    (!trimmedTextContent && !checkContentForImages(comment)) ||
    checkContentForUploadingImage(comment),
  [socketConnected, trimmedTextContent, comment]);

  return (
    <div className="chat-area pb-0">
      <div style={TASK_CHAT_AREA_STYLES} className={`${isDragNdropVisible ? '' : 'd-none'}`}>
        <FileDrop
          onDragLeave={() => {
            setIsDragNdropVisible(false);
          }}
          frame={document}
          onDrop={onFileDrop}
          onFrameDragEnter={() => {
            setIsDragNdropVisible(true);
            document.querySelector('.onResize-ticket-drawer')?.classList.add('disable-pointer-events-div');
          }}
          onFrameDragLeave={() => {
            setIsDragNdropVisible(false);
            document.querySelector('.onResize-ticket-drawer')?.classList.remove('disable-pointer-events-div');
          }}
          onFrameDrop={() => {
            setIsDragNdropVisible(false);
            document.querySelector('.onResize-ticket-drawer')?.classList.remove('disable-pointer-events-div');
          }}
        >
          <FormattedMessage id="ADD_TO_COMMENTS" defaultMessage="Add to comments" />
        </FileDrop>
      </div>
      <TextEditorWrapper
        entityId={taskId}
        entityType="task"
        placeholder={intl.formatMessage({
          id: 'TASK_CHAT_PLACEHOLDER',
          defaultMessage: 'Ask a question or post an update...',
        })}
        onChange={handleEditorChange}
        onSubmit={handleTextEditorSubmit}
        initialContent={''}
        content={comment}
        mentionOptions={mentionOptions}
        textEditorRef={textEditorRef}
      />
      {/* <div className='d-flex mb-2'>
        <TextAreaFileHolder fileImages={file} delAttachment={deleteFile} isLoading={isLoading} />
      </div> */}
      {!socketConnected && (
        <div className="message-send-banner">
          <FormattedMessage id="SOCKET_RECONNECTING" defaultMessage="Socket is reconnecting…" />
        </div>
      )}
      {socketConnected && (
        <div className="message-send-banner">
          {isImgUploadingInProgress ? (
            <FormattedMessage
              id="IMG_UPLOADING_IN_PROGRESS"
              defaultMessage="Wait for image upload to finish"
            />
          ) : (
            trimmedTextContent &&
            (isMac ? (
              <FormattedMessage
                id="SEND_COMMAND_HINT_MAC"
                defaultMessage="Cmd+Enter to send a message"
              />
            ) : (
              <FormattedMessage
                id="SEND_COMMAND_HINT_WIN"
                defaultMessage="Ctrl+Enter to send a message"
              />
            ))
          )}
        </div>
      )}
      <div
        className={`chat-send-btn ${isSendBtnDisabled ? 'disabled' : ''}`}
        onClick={handleSubmit}
      >
        <Icon name="send.svg" height="13px" />
      </div>

      {/* TODO: add File upload and emoji to + button menu */}
      {/* <div className='d-flex justify-content-between align-center'>
        <div className='d-flex align-center'>
          <Icon
            name='blueAdd.svg'
            height='15px'
            pr='8px'
            onClick={() => {
              let input = document.createElement('INPUT');
              input.style.display = 'none';
              input.setAttribute('type', 'file');
              input.setAttribute('id', 'file');
              document.body.appendChild(input);
              input.click();
              input.addEventListener('change', changeHandler);
            }}
          />
          <input
            style={{ display: 'none' }}
            id='file-input1'
            type='file'
            multiple
            onChange={changeHandler}
          /> */}
      {/* <div className='small-vertical-line' /> */}
      {/* <Icon name='video.svg' height='13px' pr='13px' />
          <Icon name='mice.svg' height='12px' pr='13px' />
          <div className='small-vertical-line' /> */}
      {/* <Icon name='smiley.svg' onClick={showModal} height='13px' pr='2px' />
          <Modal
            className={`${fullScreen
              ? 'fullScreenTaskChatAreaEmojiModal'
              : 'taskChatAreaEmojiModal'
              }`}
            style={{ marginRight: `${emojiPosition + -500}px` }}
            title='Basic Modal'
            open={isModalOpen}
            onOk={handleOk}
            onCancel={handleCancel}
          >
            <EmojiPicker onEmojiClick={handleEmoji} autoFocusSearch={false} />
          </Modal>
        </div>
      </div> */}
    </div>
  );
};

const mapStateToProps = (state) => ({
  socketConnected: isSocketConnectedSelector(state),
});

export default connect(mapStateToProps)(TaskChatArea);
